import { makeInventoryKey } from './inventoryKey';

export function buildInventoryCountsDictionary(vehicles) {
	return Object.values(vehicles)
		.flat()
		.reduce((acc, { model, gvBodyStyle, inventoryCount }) => {
			if (!model) return acc;
			acc[makeInventoryKey(model, gvBodyStyle)] = inventoryCount;
			// Bare-model entry kept for the lookupInventoryCount fallback path.
			acc[model] = inventoryCount;
			return acc;
		}, {});
}
